<template>
  <div class="auth-wrapper">
    <div>
        <UnifiedLogin
            v-if="isLoginView"
            :title="loginTitle"
            @login-success="handleLoginSuccess"
        />
        </div>
  </div>
</template>

<script>
import UnifiedLogin from '@/components/UnifiedLogin.vue' 
import axiosInstance from '@/services/AxiosClient'

const AUTH_STORAGE_KEY = 'salon_auth';
// const API_BASE_URL = `${process.env.VUE_APP_API_URL}/user`


export default {
    name: 'Authenticate',
    components: {
        UnifiedLogin,
    },
    data() {
        return {
            currentView: 'login',
            error: null,
        }
    },
    computed: {
        isLoginView() {
            return this.currentView === 'login'
        },
        loginTitle() {
            return 'Account Login';
        },
    },
    methods: {
        /*async fetchUserData() {
        try {
            const response = await axiosInstance.get('/user/data'); 
            console.log('User data:', response.data);
        } catch (error) {
            console.error('API call failed:', error);
        }
        },*/
        switchView(view) {
            this.currentView = view;
        },
        async readNumberHelper(email){
            try {
                const response = await axiosInstance.get(`/user/get_user/${email}` )
                return response.data.phone_number
            } catch(error) {
                console.error("Error fetching phone number:", error)
                return null
            }
        },
        async handleLoginSuccess(loginResponse, user, email, accessToken, refreshToken) {

            console.log("Back to the parent authentication")
            const role = user.role.toLowerCase();
            if (role) {
                console.log("role is available")
            }
            console.log("This is the role: ", role)
            const loginSession = {
                id: user.id,
                username: user.full_name,
                email: email,
                role: role,
                access_token: accessToken,
                refresh_token: refreshToken,
                loginResponse: loginResponse 
            };

    // 1. Save sessions immediately
    //localStorage.setItem('salon_auth', JSON.stringify(loginSession));

    if (role === 'stylist') {
        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(loginSession));
        console.log("In the stylist section")
        // If Google is needed, go there NOW. Do not pass Go.
        if (loginResponse.google_auth_required) {
            try {
                const res = await axiosInstance.get(`${process.env.VUE_APP_API_URL}/auth/google/login`, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
                if (res.data?.auth_url) {
                    window.location.href = res.data.auth_url;
                    return; // Stop execution
                }
            } catch (err) {
                console.error("Google flow failed:", err);
                this.error = "Could not initialize Google connection.";
                return;
            }
        }
        // 3. If Google NOT required, proceed to Dashboard
        this.$router.push({ name: 'StylistDashboard' });

    } else if (role === 'admin') {
        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(loginSession));
        console.log("In the admin section")
        this.$router.push({ name: 'adminDashboard' });
        console.log("After pushing the admin dashboard to router")
        
    }
}
    }
}
</script>

<style scoped>
.auth-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
}
</style>